import { getFullContactName } from '../../bookingOrders/utils/contactPerson';
import {
  OpenClassBookingOrder,
  OpenClassBookingOrderDetails,
  OpenClassRegistration,
} from '../types/OpenClass';

export const distinctBookingOrderIds = (
  registrations: Pick<OpenClassRegistration, 'bookingOrderId'>[],
): OpenClassBookingOrder['id'][] =>
  Array.from(
    new Set(registrations.map(({ bookingOrderId }) => bookingOrderId)),
  );

const orderName = (order: OpenClassBookingOrder): string | undefined =>
  order.clientCompany?.name ??
  order.contact?.name ??
  (order.contactPerson ? getFullContactName(order.contactPerson) : undefined);

// Two standalone orders can share a contact, so the id and date keep them apart.
export const openClassOrderLabel = (
  order: OpenClassBookingOrder | undefined,
  orderId: OpenClassBookingOrder['id'],
  unnamedLabel: string,
): string =>
  order
    ? `${orderName(order) ?? unnamedLabel} · #${orderId} · ${order.orderDate}`
    : `#${orderId}`;

// Where the backend sends a certificate when the attendee has no address of their own
export const orderContactEmail = (
  details: OpenClassBookingOrderDetails | undefined,
): string | undefined =>
  details?.order.contact?.email ?? details?.order.contactPerson?.email;
